document.addEventListener("DOMContentLoaded", function () {
  const priceFiltersEl = document.querySelectorAll(".price-filters");

  // Iterate through all priceFilters divs and add event listeners to them
  priceFiltersEl.forEach((priceFilterEl) => {
    // get price-low, price-high, and price-submit elements
    const priceLowEl = priceFilterEl.querySelector(".price-low");
    const priceHighEl = priceFilterEl.querySelector(".price-high");
    const priceSubmitEl = priceFilterEl.querySelector(".price-submit");
    // Get the current query string and if price_low or price_high are in it
    // change those values to the ones in our Els, if they aren't in it add them
    priceSubmitEl.addEventListener("click", function () {
      let query = new URLSearchParams(window.location.search);
      if (priceLowEl.value !== "") {
        query.set("price_low", priceLowEl.value);
      } else {
        query.delete("price_low");
      }
      if (priceHighEl.value !== "") {
        query.set("price_high", priceHighEl.value);
      } else {
        query.delete("price_high");
      }
      window.location.search = query.toString();
    });
  });
});
